import Service from 'react-reservice';

import {
  IPelicanCopyTradeMissedTrades,
  IPelicanCopyTradeProfile,
  IPelicanCopyTradeSignalOpenColumns
} from '@aqx-core/common/api/copy-trade/model';

export interface ICopyTradeAssetContext {
  copyTradeProfile: IPelicanCopyTradeProfile | null;
  copyTradeProfileImage: Blob | undefined;
  isLoadingCopyTradeProfile: boolean;
  isLoadingCopyTradeProfileImage: boolean;
  copyTradeMissedTrades: IPelicanCopyTradeMissedTrades[];
  isLoadingCopyTradeMissedTrades: boolean;
  isLoadingEditCopyTradeOrder: boolean;
  isLoadingCloseCopyTradeOrder: boolean;
  isLoadingGetCopyTradeOrder: boolean;
  copyTradeOrder: IPelicanCopyTradeSignalOpenColumns | null;
}

const defaultContext: ICopyTradeAssetContext = {
  copyTradeProfile: null,
  copyTradeProfileImage: undefined,
  isLoadingCopyTradeProfile: false,
  isLoadingCopyTradeProfileImage: false,
  copyTradeMissedTrades: [],
  isLoadingCopyTradeMissedTrades: false,
  isLoadingEditCopyTradeOrder: false,
  isLoadingCloseCopyTradeOrder: false,
  isLoadingGetCopyTradeOrder: false,
  copyTradeOrder: null
};

class CopyTradeAssetService extends Service<ICopyTradeAssetContext> {
  constructor() {
    super();
    this.context = { ...defaultContext };
  }

  setIsLoadingEditCopyTradeOrder = (isLoadingEditCopyTradeOrder: boolean) => {
    this.context.isLoadingEditCopyTradeOrder = isLoadingEditCopyTradeOrder;
  };

  setIsLoadingCloseCopyTradeOrder = (isLoadingCloseCopyTradeOrder: boolean) => {
    this.context.isLoadingCloseCopyTradeOrder = isLoadingCloseCopyTradeOrder;
  };

  setIsLoadingGetCopyTradeOrder = (isLoadingGetCopyTradeOrder: boolean) => {
    this.context.isLoadingGetCopyTradeOrder = isLoadingGetCopyTradeOrder;
  };

  setCopyTradeOrder = (copyTradeOrder: IPelicanCopyTradeSignalOpenColumns | null) => {
    this.context.copyTradeOrder = copyTradeOrder;
  };

  setCopyTradeProfile = (copyTradeProfile: IPelicanCopyTradeProfile | null) => {
    this.context.copyTradeProfile = copyTradeProfile;
  };

  setCopyTradeProfileImage = (copyTradeProfileImage: Blob | undefined) => {
    this.context.copyTradeProfileImage = copyTradeProfileImage;
  };

  setIsLoadingCopyTradeProfile = (isLoadingCopyTradeProfile: boolean) => {
    this.context.isLoadingCopyTradeProfile = isLoadingCopyTradeProfile;
  };

  setIsLoadingCopyTradeProfileImage = (isLoadingCopyTradeProfileImage: boolean) => {
    this.context.isLoadingCopyTradeProfileImage = isLoadingCopyTradeProfileImage;
  };

  setCopyTradeMissedTrades = (copyTradeMissedTrades: IPelicanCopyTradeMissedTrades[]) => {
    this.context.copyTradeMissedTrades = copyTradeMissedTrades;
  };

  setIsLoadingCopyTradeMissedTrades = (isLoadingCopyTradeMissedTrades: boolean) => {
    this.context.isLoadingCopyTradeMissedTrades = isLoadingCopyTradeMissedTrades;
  };
}

export const copyTradeAssetService = new CopyTradeAssetService();
